import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || '';

export default function IndianBreeds() {
  const { t } = useTranslation();
  const [breeds, setBreeds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/cattle-breeds').then(r => { setBreeds(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);
  function MyComponent() {
  const htmlString = "Paragraph with <strong>bold text</strong>.";

  return (
    <div dangerouslySetInnerHTML={{ __html: htmlString }} />
  );
}
  return (
    <div>
      <div className="page-header">
        <h1>{t('indianBreeds.pageTitle')}</h1>
        <p>{t('indianBreeds.pageSubtitle')}</p>
      </div>

      <section className="section">
        <div className="container">
          {loading ? (
            <div className="loader"><div className="spinner" /></div>
          ) : breeds.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '60px 0', color: '#888' }}>
              <div style={{ fontSize: '4rem', marginBottom: 12 }}>🐂</div>
              <p>{t('indianBreeds.noBreeds')}</p>
            </div>
          ) : (
            <div className="breed-grid">
              {breeds.map(b => (
                <div key={b._id} className="breed-card">
                  <div className="breed-photo-wrap">
                    {b.image
                      ? <img src={`${API_BASE}${b.image}`} alt={b.name} className="breed-photo" />
                      : <div className="breed-photo breed-photo-placeholder">🐂</div>
                    }
                  </div>
                  <div className="breed-info">
                    <div className="breed-name">{b.name}</div>
                    {b.origin && <div className="breed-origin">{t('indianBreeds.originLabel')}: {b.origin}</div>}
                    {/* <p className="breed-description">{b.description}</p> */}
                    <div className="breed-description" dangerouslySetInnerHTML={{ __html: b.description }} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
